import cookieService, { getCookieDomain } from 'services/cookies'
import { getLangFromUrl } from 'utils/current-language'

const redirectToLanguage = (lang: string): void => {
  const subdomain = lang.toLowerCase() === 'pl' || lang.toLowerCase() === 'null' ? '' : `${lang.toLowerCase()}.`
  window.location.href = `//${subdomain}${getCookieDomain()}/`
}

const setupToggler = (toggler: HTMLButtonElement, dropdown: HTMLDivElement): void => {
  toggler.addEventListener('click', (e) => {
    e.stopPropagation()

    const isOpen = !dropdown.hidden
    closeAllDropdowns()
    if (!isOpen) {
      dropdown.hidden = false
      toggler.setAttribute('aria-expanded', 'true')
      const firstOption = dropdown.querySelector<HTMLButtonElement>('button[role="menuitem"]')
      firstOption?.focus()
    }
  })
}

const setupOptions = (wrapper: HTMLElement): void => {
  const options = wrapper.querySelectorAll<HTMLButtonElement>('[data-lang-option]')
  options.forEach((btn) => {
    btn.addEventListener('click', () => {
      const selectedLang = btn.getAttribute('data-lang-option')
      if (!selectedLang) return
      cookieService.setItem('language', selectedLang, cookieService.maximalCookieTTL)
      redirectToLanguage(selectedLang)
    })
  })
}

const setupGlobalListeners = (): void => {
  document.addEventListener('click', () => closeAllDropdowns())

  document.addEventListener('keydown', (event: KeyboardEvent) => {
    const activeElement = document.activeElement as HTMLElement
    const wrapper = activeElement?.closest('[data-lang-switcher]')
    if (!wrapper) return

    const dropdown = wrapper.querySelector<HTMLDivElement>('[data-lang-dropdown]')
    if (!dropdown || dropdown.hidden) return

    const items = Array.from(dropdown.querySelectorAll<HTMLButtonElement>('button[role="menuitem"]'))
    const index = items.findIndex((el) => el === activeElement)

    switch (event.key) {
      case 'Escape': {
        closeAllDropdowns()
        const toggler = wrapper.querySelector<HTMLButtonElement>('[data-lang-toggler]')
        toggler?.focus()
        break
      }
      case 'ArrowDown': {
        event.preventDefault()
        items[(index + 1) % items.length]?.focus()
        break
      }
      case 'ArrowUp': {
        event.preventDefault()
        items[(index - 1 + items.length) % items.length]?.focus()
        break
      }
      case 'Enter': {
        event.preventDefault()
        if (activeElement instanceof HTMLButtonElement) {
          activeElement.click()
        }
        break
      }
    }
  })
}

const closeAllDropdowns = (): void => {
  const allDropdowns = document.querySelectorAll<HTMLDivElement>('[data-lang-dropdown]')
  const allTogglers = document.querySelectorAll<HTMLButtonElement>('[data-lang-toggler]')

  allDropdowns.forEach((dropdown) => (dropdown.hidden = true))
  allTogglers.forEach((toggler) => toggler.setAttribute('aria-expanded', 'false'))
}

const initLangSwitcher = (): void => {
  window.addEventListener('DOMContentLoaded', () => {
    const switcherWrappers = document.querySelectorAll<HTMLElement>('[data-lang-switcher]')
    const langFromUrl = getLangFromUrl() || 'pl'

    switcherWrappers.forEach((wrapper) => {
      const toggler = wrapper.querySelector<HTMLButtonElement>('[data-lang-toggler]')
      const dropdown = wrapper.querySelector<HTMLDivElement>('[data-lang-dropdown]')

      if (!dropdown || !toggler) return

      setupToggler(toggler, dropdown)
      setupOptions(wrapper)
    })

    setupGlobalListeners()

    cookieService.setItem('language', langFromUrl, cookieService.maximalCookieTTL)
  })
}

export default initLangSwitcher
